<button
  class="fdx-c-button fdx-u-border--none fdx-u-bg-color--purple fdx-u-color--white fdx-u-height--100 fdx-u-width--100"
  [ngClass]="{ 'fdx-u-bg-color--grey-30 fdx-u-color--grey-50': !isActive }"
>
  <div class="fdx-o-grid">
    <div class="fdx-u-mb--5 fdx-u-mt--10">
      @if (isActive) {
      <img [src]="iconPathForActiveButton" alt="" width="80" height="80" />
      } @if (!isActive) {
      <img [src]="iconPathForInActiveButton" alt="" width="80" height="80" />
      }
    </div>
    <div class="fdx-u-mb--5">
      <p class="fdx-u-font-size--button-regular fdx-u-text--normal">
        {{ label }}
      </p>
    </div>
  </div>
</button>
